const ExtraPoint = {
  path: "",
  name: "",
  redirect: "/extrapoint",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/extrapoint",
      redirect: "/extrapoint",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Extra Point",
      meta: {
        requiresAuth: true,
        activeUrl: "/extrapoint",
        parent: "/extrapoint",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/extraPoint"),
          meta: {
            requiresAuth: true,
            activeUrl: "/extrapoint",
            parent: "/extrapoint",

            lv: 2,
          },
        },
        {
          path: "details/:id",
          name: "Extra Point Detail",
          component: () => import("@/views/pages/extraPoint/Detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/extrapoint",
            parent: "/extrapoint",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default ExtraPoint;
